
import './styles.css';

export const Cart = ({ children }: any):JSX.Element => {
	return <div className="cart">{children}</div>;
};
